import { objectToQueryString, queryStringToParameters } from '@nubank/www-latam-commons/utils/urlUtils';

export const resolveCMSImagePath = (path, format) => {
  const [filteredPath, oldQueryParameters] = path.split('?');
  const transformedPath = filteredPath.replace(
    process.env.IMAGES_CMS_URL,
    process.env.IMAGES_NU_URL,
  );
  const queryParameters = objectToQueryString({
    ...queryStringToParameters(oldQueryParameters),
    fm: format,
  });
  return `${transformedPath}${queryParameters}`;
};

export const resolveCMSImageSrcSet = srcset => (
  Object.entries(srcset).reduce((acc, curr) => {
    const breakpoint = curr[0];
    const dprObject = curr[1];
    return {
      ...acc,
      [breakpoint]: {
        '1x': resolveCMSImagePath(dprObject['1x'], 'webp'),
        '2x': resolveCMSImagePath(dprObject['2x'], 'webp'),
        '3x': resolveCMSImagePath(dprObject['3x'], 'webp'),
      },
    };
  }, {})
);
